// Mock data para Tu Condominio Digital

export const handleContactForm = async (formData) => {
  // Simular envío de formulario
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Formulario enviado (MOCK):', formData);
      resolve({ success: true, message: 'Formulario enviado exitosamente' });
    }, 1000);
  });
};

export const services = [
  {
    id: 'residencial',
    title: 'Administración Residencial',
    description: 'Gestión integral de condominios residenciales con tecnología de punta',
    icon: 'Building2'
  },
  {
    id: 'corporativo',
    title: 'Edificios Corporativos',
    description: 'Soluciones especializadas para edificios de oficinas y corporativos',
    icon: 'Building'
  },
  {
    id: 'comercial',
    title: 'Espacios Comerciales',
    description: 'Administración de centros comerciales y espacios retail',
    icon: 'ShoppingBag'
  },
  {
    id: 'propiedades',
    title: 'Corredores de Propiedades',
    description: 'Servicios de venta y arriendo de propiedades',
    icon: 'Key'
  }
];

export const techSolutions = [
  {
    title: 'Control de Acceso con IA',
    description: 'Sistema de reconocimiento facial de última generación que identifica automáticamente a residentes y visitantes. Elimina el uso de tarjetas o llaves, aumentando la seguridad y comodidad. Incluye registro automático de ingresos y egresos con fotografías y reportes detallados en tiempo real.',
    icon: 'Scan',
    features: ['Reconocimiento facial avanzado', 'Registro automático 24/7', 'Alertas en tiempo real', 'Historial completo de accesos']
  },
  {
    title: 'Gestión de Visitas',
    description: 'Los residentes pueden autorizar visitas desde su smartphone en segundos. Configure permisos por hora específica, día completo, o acceso recurrente. El sistema notifica automáticamente al personal de seguridad y mantiene un registro completo con fotografías para máxima trazabilidad.',
    icon: 'UserCheck',
    features: ['Autorización desde app móvil', 'Permisos flexibles por tiempo', 'Notificaciones automáticas', 'Registro fotográfico']
  },
  {
    title: 'Control de Deliveries',
    description: 'Cuando llega un paquete o delivery, el sistema captura automáticamente una fotografía y notifica al residente vía app con la imagen para que autorice el ingreso. Reduce tiempos de espera, mejora la seguridad y mantiene un historial completo de todos los envíos recibidos.',
    icon: 'PackageCheck',
    features: ['Captura automática de foto', 'Notificación instantánea', 'Autorización en 1 click', 'Historial de entregas']
  },
  {
    title: 'Reserva de Espacios',
    description: 'Plataforma intuitiva para reservar áreas comunes como quincho, sala de eventos, gimnasio o estacionamiento de visitas. Los residentes ven disponibilidad en tiempo real, reservan en segundos y reciben confirmación automática. Incluye sistema de pagos integrado y recordatorios.',
    icon: 'Calendar',
    features: ['Disponibilidad en tiempo real', 'Reserva instantánea', 'Pagos integrados', 'Recordatorios automáticos']
  },
  {
    title: 'Gastos Comunes Digitales',
    description: 'Acceso completo a todos los detalles de gastos comunes desde app o web. Visualiza desglose detallado de cada ítem, historial de pagos, y paga directamente con tarjeta o transferencia. Recibe recordatorios automáticos antes del vencimiento y descarga comprobantes instantáneamente.',
    icon: 'CreditCard',
    features: ['Desglose detallado', 'Pago online seguro', 'Historial completo', 'Comprobantes digitales']
  },
  {
    title: 'Automatización de Portones',
    description: 'Control inteligente de portones peatonales y vehiculares mediante reconocimiento automático. Se integra con placas patentes, tags RFID y control desde smartphone. Apertura sin contacto, registro de todos los accesos y sincronización con el sistema de seguridad del edificio.',
    icon: 'DoorOpen',
    features: ['Apertura automática', 'Reconocimiento de patentes', 'Control desde app', 'Sincronización total']
  }
];

export const additionalServices = [
  {
    title: 'Asesoría a Comités',
    description: 'Capacitación integral, orientación estratégica y desarrollo de planes de ingresos. Acompañamiento en conformación de comités, definición de roles y optimización de gestión administrativa.',
    icon: 'Users'
  },
  {
    title: 'Planificación Anual',
    description: 'Desarrollo de presupuestos completos, calendario de mantenciones preventivas, gestión de proveedores y planificación financiera. Cobertura total de servicios de manutención del edificio.',
    icon: 'ClipboardList'
  },
  {
    title: 'Asesoría Legal',
    description: 'Soporte legal especializado en copropiedad, revisión de contratos, gestión de conflictos, cumplimiento normativo y representación en procesos legales relacionados con la comunidad.',
    icon: 'Scale'
  },
  {
    title: 'Seguridad y Prevención',
    description: 'Implementación y supervisión de protocolos de seguridad, desarrollo de planes de emergencia, capacitaciones periódicas, evaluaciones de riesgo y cumplimiento de normativas de prevención.',
    icon: 'Shield'
  },
  {
    title: 'Gobierno Corporativo',
    description: 'Preparación y conducción de asambleas, elaboración de reportes ejecutivos detallados, gestión integral de riesgos, seguimiento de acuerdos y comunicación efectiva con el comité.',
    icon: 'Briefcase'
  },
  {
    title: 'Gestión de Proveedores',
    description: 'Proceso completo de licitación transparente, evaluación y selección de proveedores, negociación de contratos, gestión de pagos y control de calidad de servicios contratados.',
    icon: 'Truck'
  },
  {
    title: 'Mantenimiento',
    description: 'Gestión preventiva y correctiva de toda la infraestructura. Incluye mantención de áreas comunes, sistemas eléctricos, sanitarios, jardines, equipos y seguimiento de garantías.',
    icon: 'Wrench'
  },
  {
    title: 'Atención al Cliente',
    description: 'Canal de atención multicanal 24/7, gestión de solicitudes y reclamos, seguimiento de casos, encuestas de satisfacción y mejora continua del servicio hacia la comunidad.',
    icon: 'Headphones'
  },
  {
    title: 'Finanzas y Contabilidad',
    description: 'Administración financiera completa con software especializado, contabilidad mensual, declaraciones tributarias, conciliaciones bancarias, control de morosidad y reportes ejecutivos.',
    icon: 'PiggyBank'
  },
  {
    title: 'Recursos Humanos',
    description: 'Reclutamiento, selección y gestión de todo el personal del edificio (conserjes, mayordomos, aseo, mantención, seguridad). Incluye contratos, remuneraciones, capacitaciones y evaluaciones.',
    icon: 'UserCog'
  }
];

export const userProfiles = [
  {
    type: 'Residentes',
    description: 'Accede a tus gastos comunes, reserva espacios y gestiona tus visitas desde tu app',
    benefits: ['Pago de gastos comunes en línea', 'Reserva de áreas comunes', 'Autorización de visitas', 'Notificaciones de deliveries'],
    icon: 'Home'
  },
  {
    type: 'Comités',
    description: 'Herramientas y asesoría para una gestión eficiente de tu comunidad',
    benefits: ['Asesoría legal y administrativa', 'Reportes ejecutivos', 'Gestión de asambleas', 'Estrategias de ingresos'],
    icon: 'Users'
  },
  {
    type: 'Mayordomos',
    description: 'Plataforma para gestionar operaciones diarias del edificio',
    benefits: ['Control de accesos', 'Gestión de mantenimiento', 'Coordinación de proveedores', 'Reportes en tiempo real'],
    icon: 'UserCheck'
  },
  {
    type: 'Proveedores',
    description: 'Sistema transparente de licitaciones y gestión de contratos',
    benefits: ['Proceso de licitación digital', 'Gestión de contratos', 'Pagos programados', 'Comunicación directa'],
    icon: 'Truck'
  }
];
